import * as types from "./contactsActionTypes";
import * as apiUrls from "./contactsApiUrls";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export function fetchUserContacts(userId, mockJson = []) {
  return (dispatch) => {
    fetch(apiUrls.apiV2UserContactsUrl(userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then((json) => {
      dispatch({
        type: types.RECEIVE_CONTACTS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function fetchPurchaseOrderContacts(userId, purchaseOrderId) {
  return (dispatch) => {
    fetch(apiUrls.apiV2PurchaseOrderContactsUrl(userId, purchaseOrderId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then((json) => {
      dispatch({
        type: types.RECEIVE_TRADE_DOCUMENT_CONTACTS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function fetchInvoiceContacts(userId, invoiceId) {
  return (dispatch) => {
    fetch(apiUrls.apiV2InvoiceContactsUrl(userId, invoiceId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then((json) => {
      dispatch({
        type: types.RECEIVE_TRADE_DOCUMENT_CONTACTS,
        payload: json,
      });
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function createUserContact(userId, body, successCallback = () => {}, errorCallback = () => {}) {
  return (dispatch, getState) => {
    fetch(apiUrls.apiV2UserContactsUrl(userId), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
      body: JSON.stringify({ buyer_contact: body }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(fetchUserContacts(userId));
          successCallback(json);
        })
      } else {
        errorCallback();
      }
    })
  };
}

export function updateUserContact(urlOpts, body, successCallback = () => {}, errorCallback = () => {}) {
  return (dispatch, getState) => {
    const { userId, contactId } = urlOpts;
    fetch(apiUrls.apiV2ContactUrl(contactId), {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
      body: JSON.stringify({ buyer_contact: body }),
    })
    .then(response => {
      if (response.ok) {
        dispatch(fetchUserContacts(userId));
        successCallback();
      } else {
        errorCallback();
      }
    })
  };
}

export function deleteUserContact(urlOpts, successCallback = () => {}, errorCallback = () => {}) {
  return (dispatch, getState) => {
    const { userId, contactId } = urlOpts;
    return fetch(apiUrls.apiV2ContactUrl(contactId), {
      method: "DELETE",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => {
      if (response.ok) {
        dispatch(fetchUserContacts(userId));
        successCallback();
      } else {
        errorCallback();
      }
    })
  };
}



// WEBPACK FOOTER //
// ./src/features/contacts/contactsActions.js